import { useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import SettingsHeading from '@/shared-components/text/components/SettingsHeading';
import Text from '@/shared-components/text/components/Text';
import ToggleSwitch from '@/shared-components/toggles/ToggleSwitch';

import '@/pages/user-settings/communication_preferences/index.css';

const OPTIONS = [
  'promotions',
  'product_updates',
  'weekly_digest'
];

export default function EmailsPreferences() {
  const t = useTranslations('common.user_settings.communication.emails');
  const [values, setValues] = useState(OPTIONS.map(() => false));

  const toggleValue = (index, val) => {
    setValues(prev => prev.map((v, i) => (i === index ? val : v)));
  };

  return (
    <>
      <SettingsHeading text={t('heading')} />
      <Text className="settings-preferences__description font-size-small">
        {t('description')}
      </Text>
      <div className="settings-preferences__permission-group">
        {OPTIONS.map((labelKey, idx) => (
          <div className="settings-preferences__permission-row" key={labelKey}>
            <span className="settings-preferences__permission-label">{t(`options.${labelKey}`)}</span>
            <ToggleSwitch
              checked={values[idx]}
              onChange={val => toggleValue(idx, val)}
            />
          </div>
        ))}
      </div>
    </>
  );
}
